import React, { useEffect, useState } from 'react';
import { SbProfilesMediaModel, SubmissionKitDocumentModel } from './components/KitModels';
import { useMedia } from 'react-use';
import { showToast } from '../shared/Toast';
import FilePreviewer from './components/FilePreviewer';
import { humanize, SubmissionKitTagsModel } from '../submission_boards/component/SbModel';

export interface SkMediaListProps {
  from: string;
  submissionKitDocuments: SubmissionKitDocumentModel[];
  submissionKitTags: SubmissionKitTagsModel[];
  sbProfilesMedias?: SbProfilesMediaModel[];
  removeFromSubmissionKit: (submissionKitDocument: SubmissionKitDocumentModel) => Promise<boolean>;
  addToSubmissionKit: (kit_document: any, tag) => Promise<boolean>;
  removeFromSbProfilesMedia?: (sbProfilesMediaModel: SbProfilesMediaModel) => Promise<boolean>;
};

export default function SubmissionKitMediaList({
  from,
  submissionKitDocuments,
  submissionKitTags,
  removeFromSubmissionKit,
  addToSubmissionKit,
  sbProfilesMedias,
  removeFromSbProfilesMedia,
}: SkMediaListProps) {
  const [submissionKitTagsSelected, setSubmissionKitTagsSelected] = useState<
    SubmissionKitTagsModel[]
  >([]);
  const [dragOverId, setDragOverId] = useState<string | null>(null);
  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);
  const removeFromSubmissionKitClickHandler = async (submissionKitDocument: any, index: number) => {
    try {
      const resp = await removeFromSubmissionKit(submissionKitDocument);
      if (resp) {
        showToast('Successfully removed media from Submission Kit', 'success');
      } else {
        showToast('Failed to remove media from Submission Kit', 'danger');
      }
    } catch (error) {
      console.error(error);
      if (
        error?.response?.data &&
        'errors' in error?.response?.data &&
        error?.response?.data?.message
      ) {
        showToast(error?.response?.data?.message, 'danger');
        return;
      }
    }
  };
  useEffect(() => {
    if(from == 'view') {
      let filteredTag = submissionKitTags.filter(
        (item) => submissionKitDocuments.findIndex((item2) => item2.tag == item.name) >= 0
      );
      console.log('filteredTag', filteredTag);
      setSubmissionKitTagsSelected(filteredTag);
    } else {
      setSubmissionKitTagsSelected([...submissionKitTags]);
    }
  }, [submissionKitTags, submissionKitDocuments]);

  const handleDrop = async (event: any, tag: string) => {
    // event.preventDefault();
    setDragOverId(null);
    const jsonItem = event.dataTransfer.getData('application/json');
    try {
      // file_content_type "video/"
      const key_document = JSON.parse(jsonItem);
      const isVideoTag = submissionKitTagsSelected.filter((item: SubmissionKitTagsModel) => {
        return item.filetype == 2 && item.name == tag;
      });
      if (isVideoTag.length > 0) {
        if (key_document.file_content_type.indexOf('video/') < 0) {
          // show error message
          showToast('Only video media supported.', 'danger');
          return;
        }
      } else {
        if (key_document.file_content_type.indexOf('image/') < 0) {
          // show error message
          showToast('Only images are supported. Please select image.', 'danger');
          return;
        }
      }
      // get SK
      //  if present in PM
      //    if added in pm then igore add
      //    if removed in pm then add
      let itemsPresent = submissionKitDocuments.filter((submissionKitDocument, index) => {
        if (submissionKitDocument.tag !== tag) {
          return false;
        }
        if (submissionKitDocument.not_show) {
          return false;
        }
        let itemsPresentTemp = sbProfilesMedias.filter((sbProfilesMedia, index) => {
          if (sbProfilesMedia.tag !== submissionKitDocument.tag) {
            return false;
          }
          if (sbProfilesMedia.media_status == 'Add') {
            return true;
          }
          return false;
        });
        if (itemsPresentTemp.length > 0) {
          return true;
        }
        let itemsPresentRemoved = sbProfilesMedias.filter((sbProfilesMedia, index) => {
          if (sbProfilesMedia.tag !== submissionKitDocument.tag) {
            return false;
          }
          if (sbProfilesMedia.media_status == 'Removed') {
            return true;
          }
          return false;
        });
        if (itemsPresentRemoved.length > 0) {
          return false;
        }
        return true;
      });
      let itemsPresentPm = [];
      if (from == 'media_request') {
        itemsPresentPm = sbProfilesMedias.filter((sbProfilesMedia, index) => {
          if (sbProfilesMedia.tag !== tag) {
            return false;
          }
          if (sbProfilesMedia.media_status == 'Remove') {
            return false;
          }
          return true;
        });
      }
      if (
        (itemsPresent && itemsPresent.length > 0) ||
        (itemsPresentPm && itemsPresentPm.length > 0)
      ) {
        showToast('Remove image/video first to add new one.', 'danger');
        return;
      }
      console.log('key_document', key_document);
      await addToSubmissionKit(key_document, tag);
    } catch (error) {
      if ('response' in error && 'data' in error.response && 'message' in error.response.data) {
        showToast(error.response.data.message, 'danger');
      } else {
        showToast('Failed to add media in submission kit, please try again.', 'danger');
      }

      console.error('Error parsing JSON data from drag event:', error);
    }
  };
  const handleDragOver = (e: any, tag: string, targetId: string) => {
    setDragOverId(targetId);
    e.preventDefault();
  };
  return (
    <div className="scrollable-content overflow-y-auto justify-items-center">
      <div className="flex w-full flex-col ">
        <div
          className={
            (is400_639Screen ? 'px-16' : 'p-0') +
            ' grid grid-cols-2 gap-6 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10'
          }
          id="list_active"
        >
          {submissionKitTagsSelected &&
            //Object.entries(submissionKitTagsSelected)
            submissionKitTagsSelected.map((item, indexTag) => (
              <div
                key={indexTag}
                id={indexTag}
                className={`px-3 py-1 border text-blue-800 text-sm 
                ${
                  dragOverId === item.name
                    ? 'bg-blue-200 border-blue-500'
                    : 'bg-white border-gray-200 hover:shadow-lg'
                }
              `}
                style={{
                  minHeight: '150px',
                }}
                onDragOver={(event: any) => {
                  console.log('onDragOver', item.name);
                  if (from != 'view') {
                    handleDragOver(event, item.name, item.name);
                  }
                }}
                onDrop={(event: any) => {
                  console.log('onDrop', item.name);
                  if (from != 'view') {
                    handleDrop(event, item.name);
                  }
                }}
              >
                <div className="justify-center flex">{humanize(item.name)}</div>

                {submissionKitDocuments.map((submissionKitDocument, indexSk) => {
                  if (submissionKitDocument.tag !== item.name) {
                    return <></>;
                  }
                  if (submissionKitDocument.not_show ?? false) {
                    return <></>;
                  }
                  return (
                    <div
                      key={indexSk}
                      className={'flex flex-1 flex-col bg-white  shadow-lg border-2 mb-1'}
                    >
                      <a target={'_blank'}>
                        <div className="flex flex-1 flex-col h-full">
                          <FilePreviewer
                            file_url={submissionKitDocument.kit_document.file_url}
                            file_name={submissionKitDocument.kit_document.file_name}
                            file_content_type={submissionKitDocument.kit_document.file_content_type}
                          />
                        </div>
                      </a>
                      {from != 'view' && (
                        <div className="px-2 py-1 justify-center flex">
                          <div
                            onClick={() => {
                              removeFromSubmissionKitClickHandler(submissionKitDocument, indexSk);
                            }}
                            className="text-xs leading-4 font-medium items-center text-blue-500 cursor-pointer"
                          >
                            Remove
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
                {sbProfilesMedias != undefined &&
                  sbProfilesMedias.map((sbProfilesMedia, indexPm) => {
                    if (sbProfilesMedia.tag !== item.name) {
                      return <></>;
                    }
                    if (sbProfilesMedia.media_status !== 'Add') {
                      return <></>;
                    }
                    return (
                      <>
                        <div
                          key={indexPm}
                          className={'flex flex-1 flex-col bg-white  shadow-lg border-2 mb-1'}
                        >
                          <a target={'_blank'}>
                            <div className="flex flex-1 flex-col h-full">
                              <FilePreviewer
                                file_url={sbProfilesMedia.kit_document.file_url}
                                file_name={sbProfilesMedia.kit_document.file_name}
                                file_content_type={sbProfilesMedia.kit_document.file_content_type}
                              />
                            </div>
                          </a>
                          <div className="px-2 py-1 justify-center flex">
                            <div
                              onClick={() => {
                                if (removeFromSbProfilesMedia) {
                                  removeFromSbProfilesMedia(sbProfilesMedia);
                                }
                              }}
                              className="text-xs leading-4 font-medium items-center text-blue-500 cursor-pointer"
                            >
                              Remove
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
